export class UpdateUserPersonalData {
  avatarUrl: string;
  firstName: string;
  lastName: string;
  sex: string;
  city: string;
  isMyLastNameFullyDisplayed: boolean;
  /**
   * Already an ISO string, or nothing when the member has no date of birth.
   * Nothing means "do not touch it", never "erase it": a profile with no date
   * is a normal profile, onboarding never required one.
   */
  dateOfBirth?: string;

  /**
   * A few lines somebody writes about themselves, shown on their member page.
   *
   * An empty string is a real answer here, unlike the date of birth: somebody
   * who clears their bio means to clear it, and the field is on the screen in
   * front of them.
   */
  description?: string;

  /**
   * Body mass in kilograms, or `null` when the member clears the field.
   *
   * The two absent values mean different things, like the date of birth above:
   * `undefined` is "not mentioned, leave it alone", `null` is "take it back".
   * The screen promises they can remove it, so the second one has to exist.
   */
  weightKg?: number | null;

  /**
   * The member's Instagram handle, or `null` when they clear the field.
   *
   * Same two absent values as the weight above: `undefined` is "not mentioned,
   * leave it alone", `null` is "take it back". The field is internal, used by
   * the back office to tag participants in the weekly post, so it is captured
   * here but never shown on the member page other members see.
   */
  instagram?: string | null;

  constructor(
    avatarUrl: string,
    firstName: string,
    lastName: string,
    sex: string,
    city: string,
    isMyLastNameFullyDisplayed: boolean,
    dateOfBirth?: string,
    description?: string,
    weightKg?: number | null,
    instagram?: string | null,
  ) {
    this.avatarUrl = avatarUrl;
    this.firstName = firstName;
    this.lastName = lastName;
    this.sex = sex;
    this.city = city;
    this.isMyLastNameFullyDisplayed = isMyLastNameFullyDisplayed;
    this.dateOfBirth = dateOfBirth;
    this.description = description;
    this.weightKg = weightKg;
    this.instagram = instagram;
  }
}
